"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolTipContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const calcPosition = ({ position }) => {
    switch (position) {
        case 'right':
            return (0, styled_components_1.css) `
        left: calc(100% + 8px);
        top: 50%;
        transform: translate(0, -50%);
      `;
        case 'left':
            return (0, styled_components_1.css) `
        right: calc(100% + 8px);
        top: 50%;
        transform: translate(0, -50%);
      `;
        case 'bottom':
            return (0, styled_components_1.css) `
        top: calc(100% + 8px);
        left: 50%;
        transform: translate(-50%);
      `;
        case 'top':
        default:
            return (0, styled_components_1.css) `
        bottom: calc(100% + 8px);
        left: 50%;
        transform: translate(-50%);
      `;
    }
};
const calcArrowPosition = ({ position, backgroundColor }) => {
    switch (position) {
        case 'left':
            return (0, styled_components_1.css) `
        left: calc(100% + 8px);
        top: calc(50% - 8px);
        border-color: transparent transparent transparent ${backgroundColor};
      `;
        case 'right':
            return (0, styled_components_1.css) `
        right: 100%;
        top: calc(50% - 8px);
        border-color: transparent ${backgroundColor} transparent transparent;
      `;
        case 'bottom':
            return (0, styled_components_1.css) `
        bottom: 100%;
        left: 50%;
        border-color: transparent transparent ${backgroundColor} transparent;
      `;
        case 'top':
        default:
            return (0, styled_components_1.css) `
        top: 100%;
        left: 50%;
        border-color: ${backgroundColor} transparent transparent transparent;
      `;
    }
};
exports.ToolTipContainer = styled_components_1.default.div `
  display: inline-block;
  font-size: 13px;
  color: #fff;
  line-height: 1.4;
  background-color: ${(props) => props.backgroundColor};
  padding: 8px 10px;
  border-radius: 8px;
  position: absolute;
  width: max-content;
  max-width: 400px;
  z-index: 10;
  ${calcPosition}
  &::after {
    content: ' ';
    position: absolute;
    margin-left: -8px;
    border-width: 8px;
    border-style: solid;
    ${calcArrowPosition}
  }
`;
